export const getAmmounts = (layer: any, stateData: any) => {
  const { airports, places, routes } = stateData;

  if (layer === "airports") {
    const actives = airports.filter(
      (airport: any) =>
        airport.isVisible && airport.isAvailable && airport.isPastAirport
    ).length;
    const totals = airports.filter(
      (airport: any) => airport.isAvailable && airport.isPastAirport
    ).length;
    return actives + "/" + totals;
  }

  if (layer === "routes") {
    const actives = routes.filter(
      (route: any) => route.isVisible && route.pastFlights > 0
    ).length;
    const totals = routes.filter((route: any) => route.pastFlights > 0).length;
    return actives + "/" + totals;
  }

  if (layer === "places") {
    const actives = places.filter(
      (place: any) => place.isVisible && place.isAvailable && place.isPastPlace
    ).length;
    const totals = places.filter(
      (place: any) => place.isAvailable && place.isPastPlace
    ).length;
    return actives + "/" + totals;
  }

  const actives = 0;
  const totals = 0;
  return actives + "/" + totals;
};

export const getGlyphiconProps = (layer: any) => {
  const className = "Warstwa_buttonIcon" + (layer.isVisible ? "" : "--hidden");
  if (layer.isVisible)
    return {
      icon: "visibility",
      className
    };

  return {
    icon: "visibility_off",
    className
  };
};
